<template>
  <div class="a">
    <!-- 头部 -->
    <titled :num="2"></titled>
    <span class="apphome">
      <div class="box">
        <div class="top">
          <div class="left"></div>
          <div class="right">
            <vchart
              style="height: calc(100vh - 220px);width:100%;"
              ref="vchart2"
            ></vchart>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>
<script>
import titled from "@/components/module/titled/titled.vue";
import vchart from "@/components/module/chart/vchart.vue";
import { alarmStatistics } from "../../api/maintain";
export default {
  components: {
    titled,
    vchart,
  },
  data() {
    return {
      dayOption: {
        legend: {
          icon: "rect",
          right: "5%",
          top: "6%",
          itemHeight: 10,
          itemWidth: 10,
          textStyle: {
            color: "inherit",
          },
        },
        grid: {
          // 距离 上右下左 的距离
          left: "5%",
          right: "5%",
          bottom: "8%",
          top: "22%",
          // 大小是否包含文本【类似于boxsizing】
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        xAxis: {
          type: "category",
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
        },
        yAxis: {
          name: "事件",
          nameTextStyle: {
            fontSize: 15,
            padding: [0, 0, 0, 30],
            color: "#999",
            rich: {
              a: {
                // 没有设置 `lineHeight`，则 `lineHeight` 为 56
              },
            },
          },
          axisLine: {
            show: true,
          },
          type: "value",
        },
        series: [
          {
            name: "信息",
            data: [150, 230, 224, 218, 135, 147, 260],
            type: "bar",
          },
          // {
          //   name: '维护',
          //   data: [150, 230, 224, 218, 135, 147, 260],
          //   type: "bar",
          // },
          // {
          //   name: '失败',
          //   data: [150, 230, 224, 218, 135, 147, 260],
          //   type: "bar",
          // },
          // {
          //   name: '检查功能',
          //   data: [150, 230, 224, 218, 135, 147, 260],
          //   type: "bar",
          // },
          // {
          //   name: '不合规格',
          //   data: [150, 230, 224, 218, 135, 147, 260],
          //   type: "bar",
          // }
        ],
      },

      optioned: {
        tooltip: {
          trigger: "item",
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "70%"],
            itemStyle: {
              normal: {
                color: function(colors) {
                  var colorList = [
                    "#64D776",
                    "#4CA5FF",
                    "#FF2F2F",
                    "#FF8540",
                    "#FFE500",
                    "#75bedc",
                  ];
                  return colorList[colors.dataIndex];
                },
              },
            },

            data: [
              { value: 1048, name: "信息" },
              { value: 735, name: "维护" },
              { value: 580, name: "失败" },
              { value: 484, name: "检查功能" },
              { value: 300, name: "不合规格" },
            ],
          },
        ],
      },
      options: [
        {
          value: "DAY",
          label: "日",
        },
        {
          value: "MON",
          label: "月",
        },
        {
          value: "YEAR",
          label: "年",
        },
      ],
      value: "DAY",
      nowDevice: {}, //当前设备
      dayData: [],
      monthData: [],
      yearData: [],
    };
  },
  computed: {
    setDeviceItem() {
      return this.$store.cacheStore.state.setDevice;
    },
  },
  watch: {
    setDeviceItem: function(val) {
      console.log(val, "123");
      if (val == "DAY") {
        this.dayOption.xAxis.data = this.dayData;
      } else if (val == "MON") {
        this.dayOption.xAxis.data = this.monthData;
      } else if (val == "YEAR") {
        this.dayOption.xAxis.data = this.yearData;
      }
      this.$refs.vchart2.setData(this.dayOption, true);
      this.nowDevice = val;
      this.getList();
    },
  },
  mounted() {
    for (let i = 1; i <= 31; i++) {
      if (i <= 24) {
        this.dayData.push(i > 9 ? i + ":00" : "0" + i + ":00");
      }
      if (i <= 12) {
        this.yearData.push(i + "月");
      }
      this.monthData.push(i + "号");
    }
    this.dayOption.xAxis.data = this.dayData;
    this.$refs.vchart2.setData(this.dayOption, true);
    // this.getList()
  },
  methods: {
    getList() {},
    handleData(data) {
      // console.log("最新事件",res);
      this.dayOption.series = [];
      this.dayOption.series.push({
        name: "消息",
        data: [],
        type: "bar",
      });
      for (let key in data) {
        //  console.log(key,data[key]);
        this.dayOption.series[0].data.push(data[key]);
      }
      // console.log(this.dayOption);
      this.$refs.vchart2.setData(this.dayOption, true);
    },
  },
};
</script>
<style lang="scss" scoped>
.box .right {
  flex: 1;
}

.box .left {
  width: 450px;
}

.left_name {
  display: block;
  margin-left: 25px;
  margin-top: 20px;
}

.apphome .left .name {
  height: 30px;
  font-family: "Microsoft YaHei";
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 30px;
  color: #999;
  margin-bottom: 5px;
}

.apphome .box {
  height: calc(100vh - 140px);
  overflow: hidden;
  /* overflow-x: scroll; */
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

.apphome .box .top {
  // display: flex;
  margin-bottom: -25px;
}

.apphome {
  padding: 15px;
  /* overflow-x: scroll; */
  display: flex;
  margin-top: 1rem;
}
</style>
